import CurrentRightsholderStore from '@App/stores/rightsholder/current-rightsholder-store'
import CreateWorkSearchStore from '@App/stores/search/work/create-work-search-store'
import PublicSearchWorksStore from '@App/stores/search/public/public-search-works-store'
import PublicSearchWritersStore from '@App/stores/search/public/public-search-writers-store'
import PublicSearchPublishersStore from '@App/stores/search/public/public-search-publishers-store'
import type { createBrowserRouter } from 'react-router'
import CreatePasswordStore from '@App/stores/user/create-password-store'
import PublisherStepStore from '@App/stores/work/steps/publisher-step-store'
import { MatchHistoryStore } from '@App/stores/rightsholder/match/match-history-store'
import CreateRightsholderStore from '@App/stores/rightsholder/create-rightsholder-store'
import RightsholderSearchStore from '@App/stores/search/rightsholder-search-store'
import WizardFlowStore from '@App/stores/wizardFlow/WizardFlowStore'
import RegistrationHistoryStore from '@App/stores/rightsholder/registrationHistory/registration-history-store'
import SongwriterSearchStore from '@App/stores/search/songwriter/songwriter-search-store'
import CurrentSongwriterStore from '@App/stores/songwriter/current-songwriter-store'
import SongwriterWriterSearchStore from '@App/stores/search/songwriter/songwriter-writer-search-store'
import SongwriterCatalogSearchStore from '@App/stores/search/songwriter/songwriter-catalog-search-store'
import SongwriterMyWriterSearchStore from '@App/stores/search/songwriter/songwriter-mywriter-search-store'
import NotificationStore from '@App/stores/user/notification-store'
import CowriterSearchPartyStore from '@App/stores/search/public/search-cowriter-store'
import CatalogTransferListStore from '@App/stores/rightsholder/catalogTransfer/catalog-transfer-list-store'
import WorkMergeRequestListStore from '@App/stores/rightsholder/workMerge/work-merge-request-list-store'
import WorkMergeRequestDetailStore from '@App/stores/rightsholder/workMerge/work-merge-request-detail-store'
import {
    getWorkMergeRequest,
    getWorkMergeRequests,
    getWorkMergeReviewRequest,
    getWorkMergeReviewRequests,
} from '@App/api/routes/rightsholder/rightsholder'
import OverclaimSearchBulkActionStore from '@App/stores/overclaim/overclaim-search-bulk-action-store'
import WorkMergeBulkActionStore from '@App/stores/search/work/work-merge-bulk-action-store'
import OverclaimSearchStore from '@App/stores/overclaim/overclaim-search-store'
import PopupStore from '@App/stores/ui/popup-state'
import PreloaderStore from '@App/stores/ui/preloader-store'
import UiStore from '@App/stores/ui/ui-store'
import AuthStore from '@App/stores/auth/auth-state'
import LibStore from '@App/stores/lib/lib-store'
import RightsholderUserStore from '@App/stores/rightsholder/rightsholder-user-store'
import UserStore from '@App/stores/user/user-store'
import StatementsStore from '@App/stores/rightsholder/statements-store'
import CatalogSearchStore from '@App/stores/search/work/catalog-search-store'
import PublisherSearchStore from '@App/stores/search/publisher-search-store'
import UnrestrictedPublisherSearchStore from '@App/stores/search/unrestricted-publisher-search-store'
import WriterSearchStore from '@App/stores/search/writer-search-store'
import WorkSearchStore from '@App/stores/search/work/work-search-store'
import ContactStore from '@App/stores/rightsholder/contact-store'
import WorkStore from '@App/stores/work/work-store'
import ExportStore from '@App/stores/export/export-store'
import OverclaimViewStore from '@App/stores/overclaim/overclaim-view-store'
import BulkUploadStore from '@App/stores/work/bulk-upload-store'
import PublicViewWorkStore from '@App/stores/search/public/public-view-work-store'
import { ClaimingToolSearchStore } from '@App/stores/search/claiming-tool-search-store'
import ClaimToolStore from '@App/stores/work/claim-tool-store'
import ThemeStore from '@App/stores/ui/theme-store'
import { TransferCatalogSearchStore } from '@App/stores/search/transfer-catalog-search-store'
import SourceSearchPublishersStore from '@App/stores/search/catalog-transfer/source-search-publishers-store'
import TargetSearchPublishersStore from '@App/stores/search/catalog-transfer/target-search-publishers-store'
import CatalogTransferWizardStore from '@App/stores/rightsholder/catalogTransfer/catalog-transfer-wizard-store'
import MatchingStore from '@App/stores/rightsholder/match/matching-store'

type RouterInstance = ReturnType<typeof createBrowserRouter>

export default class RootStore {
    preloaderStore: PreloaderStore
    popupStore: PopupStore
    uiStore: UiStore
    themeStore: ThemeStore
    authStore: AuthStore
    libStore: LibStore
    rightsholderStore: CurrentRightsholderStore
    rightsholderUserStore: RightsholderUserStore
    userStore: UserStore
    statementsStore: StatementsStore
    catalogSearchStore: CatalogSearchStore
    publisherSearchStore: PublisherSearchStore
    unrestrictedPublisherSearchStore: UnrestrictedPublisherSearchStore
    writerSearchStore: WriterSearchStore
    workSearchStore: WorkSearchStore
    contactStore: ContactStore
    matchingStore: MatchingStore
    matchHistoryStore: MatchHistoryStore
    workStore: WorkStore
    exportStore: ExportStore
    overclaimSearchStore: OverclaimSearchStore
    overclaimSearchBulkActionStore: OverclaimSearchBulkActionStore
    catalogSearchBulkActionStore: WorkMergeBulkActionStore
    overclaimViewStore: OverclaimViewStore
    bulkUploadStore: BulkUploadStore
    publicSearchWorksStore: PublicSearchWorksStore
    publicSearchWritersStore: PublicSearchWritersStore
    publicSearchPublishersStore: PublicSearchPublishersStore
    cowriterSearchPartyStore: CowriterSearchPartyStore
    publicViewWorkStore: PublicViewWorkStore
    createPasswordStore: CreatePasswordStore
    publisherStepStore: PublisherStepStore
    createRightsholderStore: CreateRightsholderStore
    rightsholderSearchStore: RightsholderSearchStore
    songwriterSearchStore: SongwriterSearchStore
    songwriterStore: CurrentSongwriterStore
    songwriterWriterSearchStore: SongwriterWriterSearchStore
    songwriterMyWriterSearchStore: SongwriterMyWriterSearchStore
    songwriterCatalogSearchStore: SongwriterCatalogSearchStore
    router: RouterInstance | undefined
    wizardFlowStore: WizardFlowStore
    claimingToolSearchStore: ClaimingToolSearchStore
    claimToolStore: ClaimToolStore
    createWorkSearchStore: CreateWorkSearchStore
    registrationHistoryStore: RegistrationHistoryStore
    notificationStore: NotificationStore
    catalogTransferListStore: CatalogTransferListStore
    workMergeRequestListStore: WorkMergeRequestListStore
    workMergeReviewListStore: WorkMergeRequestListStore
    workMergeRequestDetailStore: WorkMergeRequestDetailStore
    workMergeReviewDetailStore: WorkMergeRequestDetailStore
    catalogTransferWizardStore: CatalogTransferWizardStore
    transferCatalogSearchStore: TransferCatalogSearchStore
    transferSourcePublisherSearchStore: SourceSearchPublishersStore
    transferTargetPublisherSearchStore: TargetSearchPublishersStore

    constructor(router?: RouterInstance) {
        this.resetStore()

        // These stores do not need to be reset - they're bound to the base
        // components of the app that are *not* remounted if the user logs out
        this.libStore = new LibStore()
        this.preloaderStore = new PreloaderStore()
        this.popupStore = new PopupStore()
        this.router = router
        this.authStore = new AuthStore(this)
    }

    resetStore = () => {
        this.rightsholderStore = new CurrentRightsholderStore(this)
        this.rightsholderUserStore = new RightsholderUserStore(this)
        this.userStore = new UserStore(this)
        this.statementsStore = new StatementsStore(this)
        this.catalogSearchStore = new CatalogSearchStore(this)
        this.publisherSearchStore = new PublisherSearchStore(this)
        this.unrestrictedPublisherSearchStore = new UnrestrictedPublisherSearchStore(this)
        this.writerSearchStore = new WriterSearchStore(this)
        this.workSearchStore = new WorkSearchStore(this)
        this.contactStore = new ContactStore(this)
        this.matchingStore = new MatchingStore(this)
        this.matchHistoryStore = new MatchHistoryStore(this)
        this.workStore = new WorkStore(this)
        this.exportStore = new ExportStore(this)
        this.bulkUploadStore = new BulkUploadStore(this)
        this.publicSearchWorksStore = new PublicSearchWorksStore(this)
        this.publicSearchWritersStore = new PublicSearchWritersStore(this)
        this.publicSearchPublishersStore = new PublicSearchPublishersStore(this)
        this.cowriterSearchPartyStore = new CowriterSearchPartyStore(this)
        this.publicViewWorkStore = new PublicViewWorkStore(this)
        this.createPasswordStore = new CreatePasswordStore(this)
        this.publisherStepStore = new PublisherStepStore(this)
        this.overclaimSearchStore = new OverclaimSearchStore(this)
        this.overclaimViewStore = new OverclaimViewStore(this)
        this.createRightsholderStore = new CreateRightsholderStore(this)
        this.rightsholderSearchStore = new RightsholderSearchStore(this)
        this.songwriterSearchStore = new SongwriterSearchStore(this)
        this.songwriterStore = new CurrentSongwriterStore(this)
        this.songwriterWriterSearchStore = new SongwriterWriterSearchStore(this)
        this.songwriterMyWriterSearchStore = new SongwriterMyWriterSearchStore(this)
        this.songwriterCatalogSearchStore = new SongwriterCatalogSearchStore(this)
        this.wizardFlowStore = new WizardFlowStore(this)
        this.claimingToolSearchStore = new ClaimingToolSearchStore(this)
        this.claimToolStore = new ClaimToolStore(this)
        this.createWorkSearchStore = new CreateWorkSearchStore(this)
        this.registrationHistoryStore = new RegistrationHistoryStore(this)
        this.uiStore = new UiStore(this)
        this.notificationStore = new NotificationStore(this)
        this.catalogTransferListStore = new CatalogTransferListStore(this) // TODO: Are we able to not have this on the context?
        this.catalogTransferWizardStore = new CatalogTransferWizardStore(this)
        this.overclaimSearchBulkActionStore = new OverclaimSearchBulkActionStore(this)
        this.catalogSearchBulkActionStore = new WorkMergeBulkActionStore(this)
        this.workMergeRequestListStore = new WorkMergeRequestListStore(this, getWorkMergeRequests)
        this.workMergeReviewListStore = new WorkMergeRequestListStore(this, getWorkMergeReviewRequests)
        this.workMergeRequestDetailStore = new WorkMergeRequestDetailStore(this, getWorkMergeRequest)
        this.workMergeReviewDetailStore = new WorkMergeRequestDetailStore(this, getWorkMergeReviewRequest)
        this.transferCatalogSearchStore = new TransferCatalogSearchStore(this) // TODO: Same here - different context or something?
        this.transferSourcePublisherSearchStore = new SourceSearchPublishersStore(this)
        this.transferTargetPublisherSearchStore = new TargetSearchPublishersStore(this)
        this.resetThemeStore()
    }

    resetThemeStore = () => {
        const oldTheme = this.themeStore
        this.themeStore = new ThemeStore(this)
        if (oldTheme) {
            oldTheme.resetCurrentTheme()
        }
    }
}
